module.exports = __webpack_public_path__ + "img/home_tag(1).c29a1621.svg";